export default __webpack_public_path__ + "static/media/feature-templates-thumbnail.093113c7.png";